import { useQuery, useQueryClient, useMutation } from 'react-query'

import { api } from '../../../utils/api'
import {
  CategoriesResponseType,
  GetAllCategoryBoQuery,
  UpdateCategoryBoBody,
} from './category-type'

export const BASE_CATEGORY_URL = 'bo/categories'

export const useGetAllCategory = (params?: GetAllCategoryBoQuery) => {
  return useQuery(
    [BASE_CATEGORY_URL, params],
    async () => {
      const response = await api.savvyGold.get<CategoriesResponseType>(BASE_CATEGORY_URL, {
        isGetAll: true,
        ...params,
      })

      return response.data.data
    },

    {
      keepPreviousData: true,
    },
  )
}

export const useUpdateCategories = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (params: UpdateCategoryBoBody) => {
      const { data } = await api.savvyGold.put(`${BASE_CATEGORY_URL}`, params)
      return data
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([BASE_CATEGORY_URL])
      },
    },
  )
}
